import { AAMBeaconButton } from 'components/shared/Beacon';
import React, { Fragment, useContext } from 'react';
import { startCase, toLower } from 'lodash';
import { connect } from 'react-redux';
import { PageContext } from './StepProvider';
import { beneSteps } from './Utils';
import BeneficiaryContext from './BeneficiaryContext';
import { formatManagedBeneficiaries } from 'state/beneficiaries/BeneficiarySelectors';
import {
    formatStringIfEducationSavings,
    renderDesignationHeader,
    getDisplayName,
    informationMissingWarningNotification,
    isMissingBeneficiaryInformation
} from 'services/BeneficiaryV2';

export const BeneficiariesDetailsData = ({ handleEditClick, displayName, relationshipName, beneficiary }) => {
    return (
        <Fragment>
            <div className="b-grid-item--10-col blocked_data">
                <div className="b-typography-sans-serif--body--100 b-font-weight-light blocked_data">
                    {displayName}
                </div>
                <div className="b-typography-sans-serif--caption--300 blocked_data">{startCase(toLower(relationshipName))}</div>
            </div>
            <div className="b-grid-item--2-col">
                <AAMBeaconButton variant="tertiary" onBeaconEventClick={handleEditClick}>
                    Edit
                </AAMBeaconButton>
            </div>
            {isMissingBeneficiaryInformation(beneficiary) && informationMissingWarningNotification}
        </Fragment>
    );
};

const BeneficiariesList = ({ beneficiaries, handleEditClick }) => (
    <Fragment>
        {beneficiaries.map((beneficiary) => {
            const {
                firstName,
                lastName,
                middleName,
                nameSuffix,
                name,
                relationshipName,
                _id
            } = beneficiary || {};

            const displayName = getDisplayName({ name, firstName, middleName, lastName, nameSuffix });
            return (
                <BeneficiariesDetailsData
                    key={_id}
                    handleEditClick={() => handleEditClick(_id)}
                    displayName={displayName}
                    relationshipName={relationshipName}
                    beneficiary={beneficiary}
                />
            );
        })}
    </Fragment>
);

const BeneficiariesDetailsList = ({ manageBeneficiaries }) => {
    const { goToPage } = useContext(PageContext);
    const { setSelectedBeneficiaryId, isEsa } = useContext(BeneficiaryContext);
    const { primary, secondary } = manageBeneficiaries || {};

    const handleEditClick = (beneficiaryId) => {
        setSelectedBeneficiaryId(beneficiaryId);
        goToPage(beneSteps.BENE_EDIT_STEP);
    };

    return (
        <div className="b-grid">
            <div className="b-grid-item--12-col">
                <div className="b-typography-serif--headline--100 b-font-weight-bold">
                    {formatStringIfEducationSavings("List of Beneficiaries", isEsa)}
                </div>
                <div className="b-typography-sans-serif--body--200 b-font-weight-light">
                    {formatStringIfEducationSavings("Here are the beneficiaries you’ve named so far.", isEsa)}
                </div>
            </div>
            {primary && primary.length > 0 && (
                <Fragment>
                    <div className="b-grid-item--12-col">
                        <div className="b-typography-sans-serif--headline--50 b-font-weight-bold">
                            {renderDesignationHeader(isEsa)}
                        </div>
                    </div>
                    <BeneficiariesList beneficiaries={primary} handleEditClick={handleEditClick} />
                </Fragment>
            )}
            {secondary && secondary.length > 0 && !isEsa && (
                <Fragment>
                    <div className="b-grid-item--12-col">
                        <div className="b-typography-sans-serif--headline--50 b-font-weight-bold">
                            Secondary beneficiaries
                        </div>
                    </div>
                    <BeneficiariesList beneficiaries={secondary} handleEditClick={handleEditClick} />
                </Fragment>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    manageBeneficiaries: formatManagedBeneficiaries(state)
});

export default connect(mapStateToProps)(BeneficiariesDetailsList);